import React, { useCallback } from 'react'
import { Box, Flex, HStack, Button } from '@chakra-ui/react'

import { Page } from 'components'

export const WizardStep = ({
  title,
  onNext,
  onPrev,
  hideNavigation = false,
  children,
  ...props
}) => {
  const handleNext = useCallback(() => {
    window.scrollTo(0, 0)
    onNext && onNext()
  }, [onNext])
  const handlePrev = useCallback(() => {
    window.scrollTo(0, 0)
    onPrev && onPrev()
  }, [onPrev])

  return (
    <Flex flex={1} direction='column'>
      <Page {...props} flex={1} mb='66px'>
        {children}
      </Page>
      {!hideNavigation && (
        <Flex
          p={3}
          borderTopWidth='1px'
          position='sticky'
          bottom='0'
          width='100%'
          bg='white'
          zIndex={5400}>
          <Box flex={1} />
          <HStack spacing={5}>
            <Button variant='link' onClick={handlePrev}>
              Voltar
            </Button>
            <Button onClick={handleNext}>Próximo</Button>
          </HStack>
        </Flex>
      )}
    </Flex>
  )
}

export default WizardStep
